{
  "name": "phoenix-admin",
  "version": "2.3.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --live-reload false",
    "start:local": "npm run start -- --configuration=local",
    "build": "ng build",
    "build:development": "npm run build -- --configuration=development",
    "build:staging": "npm run build -- --configuration=staging && npm run translate:optimize",
    "build:production": "npm run build -- --configuration=production && npm run translate:optimize",
    "translate:optimize": "transloco-optimize dist/phoenix-admin/browser/assets/locales",
    "watch": "ng build --watch --configuration development",
    "lint": "ng lint",
    "explore": "source-map-explorer dist/phoenix-admin/browser/*.js"
  },
  "author": {
    "name": "Marián Vismek",
    "email": "marian.vismek@touch4it.com"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.15",
    "@angular/common": "^20.3.15",
    "@angular/compiler": "^20.3.15",
    "@angular/core": "^20.3.15",
    "@angular/forms": "^20.3.15",
    "@angular/platform-browser": "^20.3.15",
    "@angular/platform-browser-dynamic": "^20.3.15",
    "@angular/router": "^20.3.15",
    "@jsverse/transloco-optimize": "^7.0.1",
    "common-module": "^9.2.3",
    "date-fns": "^4.1.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "typescript": "~5.9.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.13",
    "@angular/cli": "^20.3.13",
    "@angular/compiler-cli": "^20.3.15",
    "@touch4it/ng_eslint_rulezz": "~1.6.2",
    "@types/node": "^20.17.32",
    "eslint-plugin-import": "^2.32.0",
    "less": "^4.2.0",
    "source-map-explorer": "^2.5.3"
  }
}
